export const booleans = [
    { value: true, label: "Yes" },
    { value: false, label: "No" }
];
